module.exports = __webpack_public_path__ + "img/1566929751.b8bdda61.jpg";